export const getNeutralColors = key => props => props.theme.v2.palette.neutrals[key];
export const getOrangeColors = key => props => props.theme.v2.palette.orange[key];
export const getVioletColors = key => props => props.theme.v2.palette.violet[key];
export const getBlueColors = key => props => props.theme.v2.palette.blue[key];
export const getlightBlue = key => props => props.theme.v2.palette.lightBlue[key];
export const getYellowColors = key => props => props.theme.v2.palette.yellow[key];
export const getRedColors = key => props => props.theme.v2.palette.red[key];
export const getGreenColors = key => props => props.theme.v2.palette.green[key];
export const getMainColor = () => props => props.theme.v2.mainColors(process.env.REACT_APP_BUILD_SITE);
